var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13264",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40217",
    transform: "translate(-880 -156)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13251",
    width: 14,
    height: 14,
    rx: 3,
    transform: "translate(883 165)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13251 - \\uC724\\uACFD\\uC120",
    d: "M3 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3m0-2h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z",
    transform: "translate(883 165)",
    style: {
      fill: "#5d5d5d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 16",
    d: "M6360.859-18615.52v-1.617a5.566 5.566 0 0 0-5.525-5.562l.752.752a1 1 0 0 1 0 1.416.979.979 0 0 1-.706.295.988.988 0 0 1-.706-.295l-2.379-2.379a1 1 0 0 1 0-1.416l2.379-2.381a.993.993 0 0 1 1.412 0 .993.993 0 0 1 0 1.412l-.6.6a7.572 7.572 0 0 1 7.37 7.561v1.617a1 1 0 0 1-1 1 1 1 0 0 1-.997-1.003z",
    transform: "translate(-5460.181 18783.199)",
    style: {
      fill: "#5d5d5d"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRotation);
export default __webpack_public_path__ + "static/media/ic_rotation.ab3337360f47758dbea14b0dedaf2ee7.svg";
export { ForwardRef as ReactComponent };